// Calculates spotlight offset based on the actual element position
import { SpotlightOffset } from '@/providers/JoyrideProvider/JoyrideProvider.tsx';

export const calculateSpotlightOffset = (
  target: string | HTMLElement,
  padding: number = 0
): SpotlightOffset => {
  // When target is already an HTMLElement, joyride positions spotlight correctly
  // Offset correction is only needed for string selectors (offset* vs getBoundingClientRect mismatch)
  if (target instanceof HTMLElement) {
    return { x: 0, y: 0, padding };
  }

  const element = document.querySelector(target);
  if (!element) return { x: 0, y: 0, padding };

  // Actual element position on screen
  const rect = element.getBoundingClientRect();

  // Joyride calculates position via offsetTop/offsetLeft relative to offsetParent
  // Needs to find the difference between these two approaches
  const htmlElement = element as HTMLElement;
  let offsetTop = htmlElement.offsetTop;
  let offsetLeft = htmlElement.offsetLeft;
  let offsetParent = htmlElement.offsetParent as HTMLElement | null;

  // Sum all offsets up to root
  while (offsetParent) {
    offsetTop += offsetParent.offsetTop;
    offsetLeft += offsetParent.offsetLeft;
    offsetParent = offsetParent.offsetParent as HTMLElement | null;
  }

  // Difference between actual position (getBoundingClientRect) and offset position
  // getBoundingClientRect accounts for scroll, so we add it
  const scrollTop = window.scrollY || document.documentElement.scrollTop;

  const realTop = rect.top + scrollTop;

  // Offset for spotlight correction (Y only, X is usually correct)
  const offsetY = Math.round(offsetTop - realTop) + 2;

  return { x: 0, y: offsetY, padding };
};
